import { requestJson } from "../core/http.js";

export class FeedbackClient {
  constructor(apiBase, appVersion, request = requestJson) {
    this.apiBase = apiBase;
    this.appVersion = appVersion;
    this.request = request;
  }

  get available() {
    return Boolean(this.apiBase);
  }

  buildPayload({ result, correct, correctedLabel, shareImage, imageDataUrl, modelVersion, engine }) {
    return {
      predicted: result.top.id,
      confidence: Number(result.confidence.toFixed(4)),
      probabilities: result.probabilities,
      is_correct: Boolean(correct),
      corrected: correct ? result.top.id : correctedLabel || null,
      consent_image: Boolean(shareImage && imageDataUrl),
      image: shareImage ? imageDataUrl || null : null,
      app_version: this.appVersion,
      model_version: modelVersion || null,
      engine: engine || null
    };
  }

  async send(input) {
    if (!this.available) throw new Error("Feedback non configurato");
    return this.request(`${this.apiBase}/api/feedback`, { method: "POST", body: this.buildPayload(input), timeoutMs: 30000 });
  }

  async remove(id) {
    if (!this.available) throw new Error("Feedback non configurato");
    if (!id) throw new Error("Identificativo mancante");
    return this.request(`${this.apiBase}/api/feedback/delete`, { method: "POST", body: { id }, timeoutMs: 15000 });
  }
}
